import { configStore } from "@/store/store";
import { Control } from "@/types/controls";
import { TreeNode } from "@/types/tree";
import { SECTION_SLUG } from "@/lib/elements/constants";
import { treeNodeReduce } from "@/lib/tree/tree";
import lodash from "lodash";
import { ImageControlInfo } from "./types";

const HARDCODED_CONTROL_PATHS_OUTSIDE_OF_CONTENT = [
  {
    elementSlug: SECTION_SLUG,
    paths: ["design.background.image"]
  }
];

export function getPathsToImageControls(section: TreeNode): ImageControlInfo[] {
  return treeNodeReduce(
    (node: TreeNode, acc: ImageControlInfo[]) => {
      const element = configStore.element(node.data.type);
      const controls = element?.controls?.contentSections || [];
      
      const contentPaths = getWpMediaControlsFromControls(controls, "content", node)
        .map(path => ({ nodeId: node.id, controlPath: path }));
      
      const hardcodedPaths = HARDCODED_CONTROL_PATHS_OUTSIDE_OF_CONTENT.find(
        item => item.elementSlug === node.data.type
      )?.paths || [];
      
      const hardcodedPathsWithNodeId = hardcodedPaths
        .map(path => ({ nodeId: node.id, controlPath: path }));
      
      return [...acc, ...contentPaths, ...hardcodedPathsWithNodeId];
    },
    section,
    []
  );
}

function getWpMediaControlsFromControls(controls: Control[], basePath: string, node: TreeNode): string[] {
  return controls.reduce((acc: string[], control) => {
    const controlPath = `${basePath}.${control.slug}`;
    
    if (control.options.type === "wpmedia") {
      acc.push(controlPath);
    }
    
    if (control.options.type === "repeater" && control.children) {
      const repeaterValue = lodash.get(node.data.properties, controlPath);
      if (Array.isArray(repeaterValue)) {
        repeaterValue.forEach((_, index) => {
          const indexedPath = `${controlPath}[${index}]`;
          acc.push(...getWpMediaControlsFromControls(control.children, indexedPath, node));
        });
      }
    } else if (control.children) {
      acc.push(...getWpMediaControlsFromControls(control.children, controlPath, node));
    }
    
    return acc;
  }, []);
}
